import { render, staticRenderFns } from "./StockOpnamePrintDetails_Company.vue?vue&type=template&id=57f8a7a2&"
import script from "./StockOpnamePrintDetails_Company.vue?vue&type=script&lang=js&"
export * from "./StockOpnamePrintDetails_Company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports